module.exports = __webpack_public_path__ + "static/media/IUL.2963ea3c.png";